export const rootConsultationPageSelector = (state) => state.consultationPage;
